<template>
  <div>
    <b-row class="mb-2">
      <b-col cols="12">
        <b-form-group label="Notes *">
          <wysiwyg v-model="formComment.comment" />
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group label="Attachment">
          <b-form-file placeholder="Choose a file"></b-form-file>
          <small class="text-muted">
            File Type * :
            <b-badge variant="warning"
              >.jpg | .jpeg | .png | .xlx | .xlxs | .doc | .docs | .pdf</b-badge
            ><br />
            File Capacity * :
            <b-badge variant="warning">2 MB / File</b-badge>
          </small>
        </b-form-group>
      </b-col>
      <b-col md="6" class="text-right">
        <button
          :disabled="!formComment.comment"
          type="button"
          class="btn btn-outline-primary w-100"
          @click="formComment.comment = ''"
          >Cancel</button
        >
      </b-col>
      <b-col md="6" class="text-right">
        <button
          :disabled="!formComment.comment"
          type="button"
          class="btn btn-primary w-100"
          @click="saveComment()"
          >Submit Comment</button
        >
      </b-col>
    </b-row>

    <div class="overflow-auto d-flex w-100" style="max-height: 400px">
      <b-row v-if="maintenanceDetailData.comments.length > 0">
        <b-col
          md="12"
          class="mb-4"
          v-for="(comment, commentIndex) in maintenanceDetailData.comments"
          :key="commentIndex"
        >
          <div class="d-flex flex-column">
            <span class="text-primary"
              ><i class="fa fa-calendar" />
              {{ moment(comment.createdAt).format('DD MMMM YYYY HH:mm') }}</span
            >
            <strong class="mr-2">{{ comment.name }}</strong>
            <span>{{ comment.comment }}</span>
          </div>
          <div class="border my-2 w-100"></div>
        </b-col>
      </b-row>
      <span class="text-muted text-center" v-else>Tidak ada komentar.</span>
    </div>
  </div>
</template>
<script>
import { maintenanceActions } from '@/src/Utils/helper'
import moment from 'moment'
export default {
  name: 'MaintenanceCommentForm',
  props: {
    maintenanceId: {
      type: Number,
      required: true,
    },
    maintenanceDetailData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formComment: {
        comment: '',
      },
    }
  },
  methods: {
    ...maintenanceActions,
    moment(date) {
      return moment(date)
    },
    async saveComment() {
      let payload = {
        id: this.maintenanceId,
        comment: this.formComment.comment,
      }
      const res = await this.saveCommentMaintenance(payload)

      if (res.status === 'success') {
        this.formComment.comment = ''
        this.$emit('refetch')
      } else {
        this.$swal(`Oops!`, res.data.message, 'error')
      }
    },
  },
}
</script>
